import { useMutation } from "@tanstack/react-query"
import axios from "axios"
import { LoginResponseDataSchema, SignupInvitationSchema } from "schema"
import { z } from "zod"

export const useInviteMutation = () => {
  return useMutation({
    mutationFn: async (signupData: z.infer<typeof SignupInvitationSchema>) => {
      const { data } = await axios.post("/auth/invite", signupData)
      return data.data as z.infer<typeof LoginResponseDataSchema>
    },
  })
}
